import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import GreenTick from '../../../assets/v2/JSX/GreenTick'
import RedCross from '../../../assets/v2/JSX/RedCross'
import Loader from '../../../components/Loader'
import Dropdown from '../../../components/v2/Dropdown'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import PriceAccordion from '../../../components/v2/accordions/PriceAccordion'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import ToggleSwitcher from '../../../components/v2/buttons/ToggleSwitcher'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { TplCompareResponse, georgianFormatter, currencySymbol } from '../../../domain/types'
import { useAppDispatch, useAppSelector } from '../../../store'
import {
  TplState,
  setCompanyOffers,
  setHeaderPassedCount,
  setOfferFromUser,
  setPaymentSchedule,
  setPaymentScheduleMethods,
  setSelectedCompanies,
} from '../../../store/tplSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'
//
//
const TplOffers = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const dispatch = useAppDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  //
  const { filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  // payment methods
  const { data: tplPaymentMethods, isLoading: isTplPaymentMethodsLoading } = api.useGetTplPaymentMethodsQuery(undefined)
  //
  // set payment method in store callback
  const setPaymentMethodInStore = useCallback(() => {
    if (tplPaymentMethods && tplPaymentMethods.length >= 1) {
      dispatch(setPaymentScheduleMethods(tplPaymentMethods))
    }
  }, [dispatch, tplPaymentMethods])
  //
  //
  // set payment method in store action
  useEffect(() => {
    setPaymentMethodInStore()

    return () => {}
  }, [setPaymentMethodInStore])
  //
  //
  const [tplCopareRequest, { isLoading: isTplOffersLoading, data: offers }] = api.useTplCompareOffersMutation()
  //
  //
  const { data: limitsFromApi, isLoading: isLimitsFromApi } = api.useGetTplLimitsByCurrencyQuery(
    filter.currency as string,
    {
      skip: !filter.currency && true,
    },
  )
  //
  //
  const { data: tplPageInfo, isLoading: isTplPageInfoLoading } = api.useGetTplOffersQuery(undefined)
  //
  const pageTitle = tplPageInfo?.translations[lang]?.title
  //
  const stepName = tplPageInfo?.translations[lang]?.stepName
  //
  //
  //
  const sendCompareRequestCallBack = useCallback(async () => {
    //
    const paymentIds = tplPaymentMethods
      ?.filter(
        (x) => x.slug.split('-')[0].toUpperCase() === filter.seletedPaymentMethod?.type.split('-')[0].toUpperCase(),
      )
      .map((x) => x.id)
    //
    if (
      filter.productCategory &&
      paymentIds &&
      filter.dates &&
      filter.dates.start &&
      filter.dates.start !== undefined &&
      filter.dates.end &&
      filter.dates.end !== undefined &&
      filter.selectedCompanies &&
      filter.selectedCompanies.length >= 1
    ) {
      try {
        //
        await tplCopareRequest({
          productCategorySlug: filter.productCategory,
          paymentScheduleTypeIds: paymentIds,
          startDate: filter.dates.start as string,
          endDate: filter.dates.end as string,
          companies: filter.selectedCompanies,
        })
        //
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage, { toastId: 'some-id-here' })
          //
        } else {
          toast.error('Some error message')
        }
      }
    }
    //
  }, [
    filter.productCategory,
    filter.selectedCompanies,
    filter.dates,
    filter.seletedPaymentMethod,
    tplCopareRequest,
    tplPaymentMethods,
  ])
  //
  //
  useEffect(() => {
    sendCompareRequestCallBack()

    return () => {}
  }, [sendCompareRequestCallBack])
  //
  //
  //
  const setOfferCompanyCallBack = useCallback(async () => {
    if (offers && offers.companies && offers.companies.length >= 1) {
      dispatch(setCompanyOffers(offers))
    }
    //
  }, [offers, dispatch])
  //
  //
  useEffect(() => {
    setOfferCompanyCallBack()

    return () => {}
  }, [setOfferCompanyCallBack])
  //
  //
  const isDisabled = offers && offers.companies && offers && offers.companies.length >= 1 ? false : true
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const mainLoader = isTplPageInfoLoading || isTplPaymentMethodsLoading || isTplOffersLoading || isLimitsFromApi
  //
  return mainLoader ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />
      </Content>

      <Container>
        <Schedule>
          <span
            className="payment-montly"
            style={{
              whiteSpace: 'nowrap',
              color: filter.seletedPaymentMethod?.type === 'MONTHLY' ? Colors.nevadaGrey : Colors.primaryBlack,
            }}
          >
            {t('monthly')}
          </span>
          <ToggleSwitcher
            activeRedBackground={true}
            defaultValue={filter.seletedPaymentMethod?.type === 'MONTHLY' ? false : true}
            onChange={(value) => {
              if (value === true) {
                // ,
                return [
                  dispatch(
                    setPaymentSchedule({
                      id: tplPaymentMethods?.find((x) => x.slug === 'ONE-TIME')?.id || 0,
                      type: 'ONE-TIME',
                    }),
                  ),
                ]
              } else {
                //
                return [
                  dispatch(
                    setPaymentSchedule({
                      id: tplPaymentMethods?.find((x) => x.slug === 'MONTHLY')?.id || 0,
                      type: 'MONTHLY',
                    }),
                  ),
                ]
              }
            }}
          />
          <span
            className="payment-annual"
            style={{
              whiteSpace: 'nowrap',
              color: filter.seletedPaymentMethod?.type === 'MONTHLY' ? Colors.primaryBlack : Colors.nevadaGrey,
            }}
          >
            {t('annual')}
          </span>
        </Schedule>

        {/*  */}
        {offers && offers.companies && offers.companies.length >= 1 ? null : (
          <RemainingCompanies
            style={{
              marginInline: 'auto',
              width: 'fit-content',
              marginTop: '30px',
            }}
            text={t('offerNotFoundChangeSetting')}
          />
        )}
        {/*  */}

        <Block>
          {(offers && offers.companies && offers.companies.length >= 1
            ? offers.companies
            : (filter.companyOffers as TplCompareResponse).companies
          )?.map((item, index) => {
            //
            const price =
              offers && offers.companies && offers.companies.length >= 1
                ? filter.offer?.paymentScheduleType.slug === 'ONE-TIME'
                  ? georgianFormatter.format(item.totalPaymentAmount)
                  : georgianFormatter.format(item.firstPaymentAmount)
                : '0'
            //
            return (
              <PriceAccordion
                key={index}
                isBestPrice={item.isBestOption}
                price={`${price}${currencySymbol(filter.currency)}`}
                docUrl={item.wordingFilePath?.translations?.[lang]?.url}
                headTitle={filter.incomeCompanies?.find((x) => x.id === item.id)?.brandName?.[lang]?.title}
                imgUrl={filter.incomeCompanies?.find((x) => x.id === item.id)?.cover}
                isSelected={item.id === filter.offerFromUser?.id ? true : false}
                onClick={() => {
                  if (item.id === filter.offerFromUser?.id) {
                    return dispatch(setOfferFromUser(undefined))
                  } else {
                    return dispatch(setOfferFromUser(item))
                  }
                }}
              >
                {/* CONTENT */}
                <HR />

                <DropdownTitle>{t('changeCompany')}</DropdownTitle>

                <Dropdown
                  title={`${t('currency')}`}
                  value={item.currency}
                  options={filter.currencies?.map((x) => ({
                    value: x,
                    label: x,
                  }))}
                  placeholder={``}
                  onChange={(obj) => {
                    //
                    const editedCompanyCurrency = filter.selectedCompanies?.map((c) =>
                      c.id === item.id ? { ...c, currency: obj.value } : c,
                    )
                    //
                    return dispatch(setSelectedCompanies(editedCompanyCurrency))
                  }}
                />

                <br />

                <Dropdown
                  title={`${t('limit')}`}
                  value={item.limit}
                  options={limitsFromApi?.map((x) => ({
                    value: x,
                    label: `${x}`,
                  }))}
                  placeholder={``}
                  onChange={(obj) => {
                    //
                    const editedCompanyLimit = filter.selectedCompanies?.map((c) =>
                      c.id === item.id ? { ...c, limit: obj.value } : c,
                    )
                    //
                    return dispatch(setSelectedCompanies(editedCompanyLimit))
                  }}
                />

                <br />

                <Services $isDisabled={isDisabled}>
                  <ServicesTitle>{t('services')}</ServicesTitle>

                  {filter.incomeServices?.map((serviceItem, serviceIndex) => (
                    <TextDiv key={serviceIndex}>
                      <LeftText>{serviceItem.translations?.[lang]?.name}</LeftText>
                      <RightText>
                        {item?.packageServices?.find((x) => x.id === serviceItem.id) ? <GreenTick /> : <RedCross />}
                      </RightText>
                    </TextDiv>
                  ))}
                </Services>

                {offers &&
                offers.companies &&
                offers.companies.length >= 1 &&
                filter.seletedPaymentMethod?.type === 'MONTHLY' ? (
                  <>
                    <HR />
                    <OfferTextBox>
                      <OffetTextLeftSide>{t('paymentSchedule')}</OffetTextLeftSide>
                      <OffetTextRightSide>{item?.paymentScheduleType.translations?.[lang]?.title}</OffetTextRightSide>
                    </OfferTextBox>

                    {item.firstPaymentAmount && (
                      <OfferTextBox>
                        <OffetTextLeftSide>{t('firstPayment')}</OffetTextLeftSide>
                        <OffetTextRightSide>
                          {item?.firstPaymentAmount} {currencySymbol(filter.currency)}
                        </OffetTextRightSide>
                      </OfferTextBox>
                    )}

                    <OfferTextBox>
                      <OffetTextLeftSide>{t('eachPayment')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {item?.monthlyPaymentAmount} {currencySymbol(filter.currency)}
                      </OffetTextRightSide>
                    </OfferTextBox>

                    <OfferTextBox>
                      <OffetTextLeftSide>{t('totalAmount')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {item?.totalPaymentAmount} {currencySymbol(filter.currency)}
                      </OffetTextRightSide>
                    </OfferTextBox>
                  </>
                ) : null}

                {/* CONTENT */}
              </PriceAccordion>
            )
          })}
        </Block>
      </Container>

      <Content>
        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [
              dispatch(setHeaderPassedCount(screenHeader.passedCount - 1)),
              navigate('/tpl-which-method'),
            ]}
          />
          <NavigationButton
            disabled={filter.offerFromUser ? false : true}
            text={`${t('next')}`}
            buttonType="next"
            onClick={() => [dispatch(setHeaderPassedCount(7)), navigate('/tpl-offer')]}
          />
        </Buttons>
      </Content>

      <BackgroundIcon shortKite={true} />
    </Wrapper>
  )
}
//
const OffetTextLeftSide = styled.span`
  color: ${Colors.primaryGrey};
  font-size: 14px;
`
const OffetTextRightSide = styled.span`
  color: ${Colors.primaryBlack};
  font-size: 14px;
  text-transform: capitalize;
  text-align: right;
`
const OfferTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
`
const RightText = styled.div``
const LeftText = styled.div``
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`
const Schedule = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 32px;
  position: relative;
  width: fit-content;
  margin-inline: auto;

  .payment-montly {
    right: 35px;
  }

  .payment-annual {
    left: 35px;
  }

  span {
    position: absolute;
    font-size: 14px;
    line-height: 17px;
    color: ${Colors.primaryBlack};
    :first-child {
      padding-right: 10px;
    }
    :last-child {
      padding-left: 10px;
    }
  }
  svg {
    color: ${Colors.secondaryGrey};
  }

  ${Responsive.mobile} {
    margin-block: 24px;
  }
`
const HR = styled.hr`
  background-color: ${Colors.secondaryGrey};
  margin-block: 24px;
`
const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  column-gap: 32px;
  row-gap: 20px;
  margin-top: 32px;

  ${Responsive.tablet} {
    flex-direction: column;
  }

  ${Responsive.mobile} {
    flex-direction: column;
  }
`
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  width: 100%;
  padding-inline: 20px;
  z-index: 1;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`
const DropdownTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const ServicesTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const Services = styled.div<{ $isDisabled: boolean }>`
  user-select: ${(props) => (props.$isDisabled ? 'none' : 'unset')};
  pointer-events: ${(props) => (props.$isDisabled ? 'none' : 'unset')};
  opacity: ${(props) => (props.$isDisabled ? '0.6' : 'unset')};
`
//
export default TplOffers
